function setInfo(companyCode, businessName, userName) {
  if (window.jivo_api) {
    const info = window.jivo_api.getContactInfo();
    let name = info.client_name || userName;

    name = `${userName} - ID: ${companyCode}`;

    window.jivo_api.setContactInfo({
      name,
      email: localStorage.getItem('email') || info.email,
      phone: info.phone,
      description: `ID Empregador: ${companyCode} Empresa: ${businessName}`,
    });
  } else {
    setTimeout(() => {
      setInfo(companyCode, businessName, userName);
    }, 2000);
  }
}

function loadScript(path, companyCode, businessName, userName) {
  const script = document.createElement('script');
  script.id = 'jivochat';
  script.src = path;
  script.addEventListener('load', () => {
    setInfo(companyCode, businessName, userName);
  });

  document.body.appendChild(script);
}

export const verifyChat = (chat, companyCode, businessName, userName) => {
  const currentChat = localStorage.getItem('puntuChatId');
  if (!currentChat) {
    localStorage.setItem('puntuChatId', chat);
    loadScript(chat, companyCode, businessName, userName);
  }

  if (currentChat && currentChat !== chat) {
    localStorage.setItem('puntuChatId', chat);
    document.location.reload();
  }

  if (currentChat && currentChat === chat) {
    loadScript(currentChat, companyCode, businessName, userName);
  }
};

export const toggleChat = (openChat) => {
  const chatElement = document.getElementsByClassName('globalClass_ET');

  if (chatElement && chatElement.length) {
    if (!openChat) {
      chatElement[0].style.display = 'none';
    } else {
      chatElement[0].style.display = 'block';
    }
  }
};
